var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "npb-pincode-wrapper" }, [
    _c("div", { staticClass: "npb-pincode-inner-wrapper" }, [
      _vm.target
        ? _c("label", { staticClass: "npb-pincode-label" }, [
            _vm.channelTarget === "FLASH_CALL" ||
            _vm.channelTarget === "VOICE_CALL"
              ? _c("span", [_c("i18n", { attrs: { val: "calling_to" } })], 1)
              : _c(
                  "span",
                  [_c("i18n", { attrs: { val: "code_has_been_sent_to" } })],
                  1
                ),
            _vm._v(" "),
            _c("span", { staticClass: "npb-pincode-target" }, [
              _vm._v(_vm._s(_vm.target)),
            ]),
          ])
        : _c(
            "label",
            { staticClass: "npb-pincode-label" },
            [_c("i18n", { attrs: { val: "phone_confirmation_code" } })],
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "npb-pincode-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.pin1,
              expression: "pin1",
              modifiers: { number: true },
            },
          ],
          ref: "pin1",
          staticClass: "npb-pincode",
          attrs: {
            type: "tel",
            maxlength: "1",
            autocomplete: "off",
            "data-name": "pin1",
          },
          domProps: { value: _vm.pin1 },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.pin1 = _vm._n($event.target.value)
              },
              _vm.onPincodeChange,
            ],
            keydown: _vm.onPincodeChange,
            focus: _vm.onFieldFocused,
            paste: _vm.onPaste,
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.pin2,
              expression: "pin2",
              modifiers: { number: true },
            },
          ],
          ref: "pin2",
          staticClass: "npb-pincode",
          attrs: {
            type: "tel",
            maxlength: "1",
            autocomplete: "off",
            "data-name": "pin2",
          },
          domProps: { value: _vm.pin2 },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.pin2 = _vm._n($event.target.value)
              },
              _vm.onPincodeChange,
            ],
            keydown: _vm.onPincodeChange,
            focus: _vm.onFieldFocused,
            paste: _vm.onPaste,
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.pin3,
              expression: "pin3",
              modifiers: { number: true },
            },
          ],
          ref: "pin3",
          staticClass: "npb-pincode",
          attrs: {
            type: "tel",
            maxlength: "1",
            autocomplete: "off",
            "data-name": "pin3",
          },
          domProps: { value: _vm.pin3 },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.pin3 = _vm._n($event.target.value)
              },
              _vm.onPincodeChange,
            ],
            keydown: _vm.onPincodeChange,
            focus: _vm.onFieldFocused,
            paste: _vm.onPaste,
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.pin4,
              expression: "pin4",
              modifiers: { number: true },
            },
          ],
          ref: "pin4",
          staticClass: "npb-pincode",
          attrs: {
            type: "tel",
            maxlength: "1",
            autocomplete: "off",
            "data-name": "pin4",
          },
          domProps: { value: _vm.pin4 },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.pin4 = _vm._n($event.target.value)
              },
              _vm.onPincodeChange,
            ],
            keydown: _vm.onPincodeChange,
            focus: _vm.onFieldFocused,
            paste: _vm.onPaste,
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "npb-pincode-resend" }, [
      _vm.timerCount
        ? _c("div", [_c("span", [_vm._v(_vm._s(_vm.timerCount))])])
        : _vm._e(),
      _vm._v(" "),
      _vm.channel && _vm.currentChannel && !_vm.timerCount
        ? _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onResendCode.apply(null, arguments)
                },
              },
            },
            [_c("i18n", { attrs: { val: "resend" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.startSend
        ? _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                "~click": function ($event) {
                  return _vm.onSendCode.apply(null, arguments)
                },
              },
            },
            [_c("i18n", { attrs: { val: "send" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.supportButton && !_vm.channel && !_vm.timerCount
        ? _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.showSupportChat.apply(null, arguments)
                },
              },
            },
            [_c("i18n", { attrs: { val: "support_help" } })],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }